import { pickBy } from 'lodash';

export const removeEmptyKeysFromObject = (
  payload: object,
): Partial<typeof payload> => {
  return pickBy<typeof payload>(payload, x => !!x);
};

export const safeParse = (str?: string | null) => {
  try {
    return str ? JSON.parse(str) : undefined;
  } catch (e) {
    return;
  }
};
